/* eslint-disable @typescript-eslint/no-explicit-any */
import { formatCurrency } from '@/common/helpers/mask.helpers';

interface Props {
  formik: any;
  rules: any;
  baseValue: number;
}

export default function CreditCardInformations({ formik, rules }: Props) {
  return (
    <>
      {/* Valor da entrada */}
      {formik.values.creditCard.entryValue > 0 && (
        <div className="bg-gray-50 p-3 rounded border">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Valor da entrada (R$)
          </label>
          <div className="text-lg font-semibold text-gray-900">
            {formatCurrency(formik.values.creditCard.entryValue)}
          </div>
        </div>
      )}

      {/* Resumo do Cartão de Crédito */}
      {rules.canInstallment && (
        <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-4 rounded-lg border border-blue-200">
          <label className="block text-sm font-medium text-blue-800 mb-2">
            💳 Resumo do Cartão de Crédito
          </label>

          <div className="space-y-2 text-sm">
            {/* Entrada (se houver) */}
            {formik.values.creditCard.entryValue > 0 && (
              <div className="flex justify-between">
                <span className="text-gray-600">Entrada:</span>
                <span className="font-medium text-green-600">{formatCurrency(formik.values.creditCard.entryValue)}</span>
              </div>
            )}

            {/* Valor que vai para o cartão */}
            <div className="flex justify-between">
              <span className="text-gray-600">Valor no cartão:</span>
              <span className="font-medium">{formatCurrency(formik.values.creditCard.cardValue)}</span>
            </div>

            {/* Informações sobre juros (apenas se parcelado) */}
            {formik.values.creditCard.installments > 1 && (
              <div className="bg-orange-50 border border-orange-200 rounded p-2">
                <div className="flex justify-between mb-1">
                  <span className="text-gray-600">Juros mensais:</span>
                  <span className="font-medium text-orange-600">{formik.values.creditCard.fees.rate}% a.m.</span>
                </div>
                <div className="flex justify-between mb-1">
                  <span className="text-gray-600">Taxa fixa:</span>
                  <span className="font-medium text-orange-600">R$ {formik.values.creditCard.fees.fixed.toFixed(2)}</span>
                </div>
                <div className="text-xs text-orange-700 mt-1">
                  ⚠️ Juros compostos aplicados mensalmente
                </div>
              </div>
            )}

            {/* Valor total com juros no cartão */}
            <div className="border-t border-blue-200 pt-2">
              <div className="flex justify-between">
                <span className="text-blue-800 font-medium">Total no cartão:</span>
                <span className="font-bold text-blue-900">{formatCurrency(formik.values.creditCard.finalCardValue)}</span>
              </div>

              {/* Mostrar valor dos juros calculados */}
              {formik.values.creditCard.installments > 1 && (
                <div className="flex justify-between mt-1">
                  <span className="text-orange-600 text-xs">Juros totais:</span>
                  <span className="font-medium text-orange-600 text-xs">
                    +{formatCurrency(formik.values.creditCard.finalCardValue - formik.values.creditCard.cardValue)}
                  </span>
                </div>
              )}

              {/* Parcelamento com valor correto */}
              {formik.values.creditCard.installments > 1 && (
                <div className="flex justify-between mt-2">
                  <span className="text-blue-800 font-medium">Parcelamento:</span>
                  <span className="font-bold text-green-700">
                    {formik.values.creditCard.installments}x de {formatCurrency(formik.values.creditCard.installmentValue)}
                  </span>
                </div>
              )}

              {/* À vista (se for 1x) */}
              {formik.values.creditCard.installments === 1 && (
                <div className="flex justify-between mt-1">
                  <span className="text-blue-800 font-medium">Pagamento:</span>
                  <span className="font-bold text-green-700">À vista</span>
                </div>
              )}
            </div>

            {/* Total geral (entrada + cartão) */}
            {formik.values.creditCard.entryValue > 0 && (
              <div className="bg-green-50 border border-green-200 rounded p-2 mt-2">
                <div className="flex justify-between text-sm">
                  <span className="font-medium text-green-800">Total geral:</span>
                  <span className="font-bold text-green-900">
                    {formatCurrency(formik.values.creditCard.totalGeneral)}
                  </span>
                </div>
                <div className="text-xs text-green-700 mt-1">
                  {formik.values.creditCard.entryValue > 0 &&
                    `Entrada: ${formatCurrency(formik.values.creditCard.entryValue)} + Cartão: ${formatCurrency(formik.values.creditCard.finalCardValue)}`
                  }
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}